/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/jsx-pascal-case */
// eslint-disable-next-line import/no-anonymous-default-export
import React from "react";
import "../../styles/chegadaAveiro.css";
import Universidade from "../../imgs/ChegadaAveiro/uni_aereo.jpg";
import Transportes from "./Transportes";
import Residencias from "../../imgs/ChegadaAveiro/residencias.jpeg";
import PrimaryBTN from "../BTN/primaryBTN";
import { Regularizacao_Portugal, Regularizacao_Portugal_link } from "./Regularizacao_Portugal";

import Ponto_1 from "../../imgs/ChegadaAveiro/ponto_1.svg";
import Ponto_2 from "../../imgs/ChegadaAveiro/ponto_2.svg";
import Ponto_3 from "../../imgs/ChegadaAveiro/ponto_3.svg";
import Ponto_4 from "../../imgs/ChegadaAveiro/ponto_4.svg";
import Ponto_5 from "../../imgs/ChegadaAveiro/ponto_5.svg";
import Ponto_6 from "../../imgs/ChegadaAveiro/ponto_6.svg";

import { withNamespaces } from 'react-i18next';
import { Link } from "react-router-dom";

const ChegadaAveiro = ({ t }) => {

return (
  <>
    <div className="container">
      {/* AREA 1 COMO CHEGAR À UNIVERSIDADE */}
      <div id="1" className="fantasmaAncora"></div>
      <div className="row mb-3 mt-4">
        <div className="col-md-4 mb-3">
          <h2>{t('moduleChegadaAveiro:S1.T')}</h2>
          <div className="orange_line"></div>
        </div>
        <div className="col-md-8">
          <img
            src={Universidade}
            alt={t('moduleChegadaAveiro:S1.Alt1')}
            className="img_only_next"
          />
          <p className="p_next"
            dangerouslySetInnerHTML={{ __html: t('moduleChegadaAveiro:S1.P1') }}>
          </p>
          <Transportes />
        </div>
      </div>
      {/* AREA 2 ALOJAMENTO */}
      <div id="2" className="fantasmaAncora"></div>
      <div className="row mb-3 mt-4">
        <div className="col-md-4 mb-3">
          <h2>{t('moduleChegadaAveiro:S2.T')}</h2>
          <div className="orange_line"></div>
        </div>
        <div className="col-md-8">
          <p className="p_next"
            dangerouslySetInnerHTML={{ __html: t('moduleChegadaAveiro:S2.P1') }}>
          </p>
          <p className="p_next">
            <span className="p_next"
              dangerouslySetInnerHTML={{ __html: t('moduleChegadaAveiro:S2.P2.P1') }}>
            </span>
            <a className="link" href={"mailto:" + t('moduleChegadaAveiro:S2.P2.Email')}>
              {t('moduleChegadaAveiro:S2.P2.Email')}
            </a>
            {t('moduleChegadaAveiro:S2.P2.P2')}
          </p>
          <p className="p_next"
            dangerouslySetInnerHTML={{ __html: t('moduleChegadaAveiro:S2.P3') }}>
          </p>
          <img
            src={Residencias}
            alt={t('moduleChegadaAveiro:S2.Alt')}
            className="img_only"
          />
        </div>
      </div>

      {/* AREA 3 UA_INTERCULTURAL */}
      <div id="3" className="fantasmaAncora"></div>
      <div className="row mb-3 mt-4">
        <div className="col-md-4 mb-3">
          <h2>{t('moduleChegadaAveiro:S3.T')}</h2>
          <div className="orange_line"></div>
        </div>
        <div className="col-md-8">
          <p className="p_next"
            dangerouslySetInnerHTML={{ __html: t('moduleChegadaAveiro:S3.P1') }}>
          </p>
          <p className="p_next"
            dangerouslySetInnerHTML={{ __html: t('moduleChegadaAveiro:S3.P2') }}>
          </p>
          <PrimaryBTN
            alinhar="text-end mb-4"
            link="/processointegracao#ua_intercultural"
            title={t('moduleBotoes:B4.Title.B1')}
            texto={t('moduleBotoes:B4.B')}
          />
        </div>
      </div>

      {/* AREA 4 CLAIM_UA */}
      <div id="4" className="fantasmaAncora"></div>
      <div className="row mb-3">
        <div className="col-md-4 mb-3" id="1">
          <h2>{t('moduleChegadaAveiro:S4.T')}</h2>
          <div className="orange_line"></div>
        </div>
        <div className="col-md-8">
          <p className="p_next"
            dangerouslySetInnerHTML={{ __html: t('moduleChegadaAveiro:S4.P1') }}>
          </p>
          <p className="p_next">
            {t('moduleChegadaAveiro:S4.P2.P1')}
            <a className='link' href={t('moduleChegadaAveiro:S4.P2.Link')} target='_blank' rel='noreferrer'>{t('moduleChegadaAveiro:S4.P2.NameLink')}</a>
            {t('moduleChegadaAveiro:S4.P2.P2')}
          </p>
          <PrimaryBTN
            alinhar="text-end mb-4"
            link="/processointegracao#claim_ua"
            title={t('moduleBotoes:B4.Title.B2')}
            texto={t('moduleBotoes:B4.B')}
          />
        </div>
      </div>

      {/* AREA 5 FORMALIDADES ACADEMICAS */}
      <div id="5" className="fantasmaAncora"></div>
      <div className="row mb-3">
        <div className="col-md-4 mb-3">
          <h2>{t('moduleChegadaAveiro:S5.T')}</h2>
          <div className="orange_line"></div>
        </div>
        <div className="col-md-8">
          <div id="paco" className="fantasmaAncora"></div>
          <h3>{t('moduleChegadaAveiro:S5.ST1.ST')}</h3>
          <p className="p_next">
            <span dangerouslySetInnerHTML={{ __html: t('moduleChegadaAveiro:S5.ST1.P.P1') }}>
            </span>
            <a className='link' href={t('moduleChegadaAveiro:S5.ST1.P.Link')} target='_blank' rel='noreferrer' dangerouslySetInnerHTML={{ __html: t('moduleChegadaAveiro:S5.ST1.P.NameLink') }}></a>
            <span dangerouslySetInnerHTML={{ __html: t('moduleChegadaAveiro:S5.ST1.P.P2') }}>
            </span>
          </p>
          <div id="turmas_horarios" className="fantasmaAncora"></div>
          <h3>{t('moduleChegadaAveiro:S5.ST2.ST')}</h3>
          <p className="p_next">
            <span dangerouslySetInnerHTML={{ __html: t('moduleChegadaAveiro:S5.ST2.P1.P1') }}>
            </span>
            <a className='link' href={t('moduleChegadaAveiro:S5.ST2.P1.Link')} target='_blank' rel='noreferrer'>{t('moduleChegadaAveiro:S5.ST2.P1.NameLink')}</a>
            <span dangerouslySetInnerHTML={{ __html: t('moduleChegadaAveiro:S5.ST2.P1.P2') }}>
            </span>
          </p>
          <p>
            {t('moduleChegadaAveiro:S5.ST2.P2')}
          </p>
        </div>
      </div>

      {/* AREA 6 REGULARIZACAO EM PORTUGAL */}
      <div id="6" className="fantasmaAncora"></div>
      <div className="row mb-3 mt-4">
        <div className="col-md-4 mb-3">
          <h2>{t('moduleChegadaAveiro:S6.T')}</h2>
          <div className="orange_line"></div>
        </div>
        <div className="col-md-8">
          <Regularizacao_Portugal_link
            id="sef"
            img={Ponto_1}
            alt="Número 1"
            title={t('moduleChegadaAveiro:S6.ST1.ST')}
            text={t('moduleChegadaAveiro:S6.ST1.P1.P1')}
            number={t('moduleChegadaAveiro:S6.ST1.P1.Tel')}
            link={t('moduleChegadaAveiro:S6.ST1.P1.Link')}
            nameLink={t('moduleChegadaAveiro:S6.ST1.P1.NameLink')}
            text2={t('moduleChegadaAveiro:S6.ST1.P1.P2')}
            text3={t('moduleChegadaAveiro:S6.ST1.P1.P3')}
            />

          <Regularizacao_Portugal
            id="comprovativo_morada"
            img={Ponto_2}
            alt="Número 2"
            title={t('moduleChegadaAveiro:S6.ST2.ST')}
            text={t('moduleChegadaAveiro:S6.ST2.P1')}
          />

          <Regularizacao_Portugal
            id="nif"
            img={Ponto_3}
            alt="Número 3"
            title={t('moduleChegadaAveiro:S6.ST3.ST')}
            text={t('moduleChegadaAveiro:S6.ST3.P1')}
          />

          <Regularizacao_Portugal
            id="abertura_conta"
            img={Ponto_4}
            alt="Número 4"
            title={t('moduleChegadaAveiro:S6.ST4.ST')}
            text={t('moduleChegadaAveiro:S6.ST4.P1')}
          />

          <Regularizacao_Portugal
            id="cartao_estudante"
            img={Ponto_5}
            alt="Número 5"
            title={t('moduleChegadaAveiro:S6.ST5.ST')}
            text={t('moduleChegadaAveiro:S6.ST5.P1')}
          />

          <Regularizacao_Portugal
            id="inscricao_sns"
            img={Ponto_6}
            alt="Número 6"
            title={t('moduleChegadaAveiro:S6.ST6.ST')}
            text={t('moduleChegadaAveiro:S6.ST6.P1')}
          />
        </div>
      </div>
    </div>
  </>
);
};

export default withNamespaces()(ChegadaAveiro);
